export default __webpack_public_path__ + "static/media/fourth.8afd7844.mp4";